import TeamsPageNameCell from 'pages/Teams/Cells/NameCell';
import type { ManagedTeamsType } from '../..';

interface CellProps {
  rowData: ManagedTeamsType;
}

export default function TeamNameCell({ rowData }: CellProps) {
  const hasNoAccounts =
    !rowData.platformAccounts || rowData.platformAccounts.length === 0;

  return (
    <TeamsPageNameCell
      hideLogo
      rowData={rowData}
      openInNewTab
      disabled={hasNoAccounts}
    />
  );
}
